'use strict';

import {gsap} from 'gsap';
import 'scrollTo';
import 'moment';

import Loader from '../../../_modules/loader/loader';
import CarerDetail from '../../../_modules/carer-detail/carer-detail';

import { isFieldEmpty, isValidEmail, displayErrors, isValidDob, autofocusDob, goToNextSection, toggleProgressBar, initiateAutoCompleteSuburb } from './_helper';
import { toaster } from './_material';
import { carerDetails, isCarerFormValid } from '../../../_modules/carer-detail/carer-detail';

let $header = $('.header'),
    $newPatient = $('.section.new-patient'),
    $title = $('#ClientTitle'),
    $firstName = $('#FirstName'),
    $lastName = $('#LastName'),
    $dobDay = $('#DobDay'),
    $dobMonth = $('#DobMonth'),
    $dobYear = $('#DobYear'),
    $gender = $('#Gender'),
    $primaryContact = $('#PrimaryContact'),
    $doNotCall = $('#IsDoNotCallOpted'),
    $homeNumber = $('#HomeNumber'),
    $mobileNumber = $('#MobileNumber'),
    $emailAddress = $('#EmailAddress'),
    $urNumber = $('#UrNumber'),
    $patientHaveCarer = $('#PatientHaveCarer'),
    $carerFirstName = $('.carer-details__row .CarerFirstName'),
    $carerLastName = $('.carer-details__row .CarerLastName'),
    $carerPrimaryNumber = $('.carer-details__row .CarerPrimaryNumber'),
    $carerEmailAddress = $('.carer-details__row .CarerEmailAddress'),
    $carerRelationshipToClient = $('#CarerRelationshipToClient'),
    $newCarerRelationshipToClient = $('#NewCarerRelationshipToClient option'),
    $carerRelationshipToClientDefaultOption = $('select#CarerRelationshipToClient > option:first-child'),
    $newCarerRelationshipToClientDefaultOption = $('select#NewCarerRelationshipToClient > option:first-child'),
    $addressLine1 = $('#street_number'),
    $addressLine2 = $('#route'),
    $addressSuburb = $('#locality'),
    $suburbStatePostcode = $('#SuburbStatePostcode'),
    $addressPostCode = $('#postal_code'),
    $addressState = $('#administrative_area_level_1'),
    $addressAdditionalNotes = $('#AdditionalAddressNotes'),
    $printedVersionSupplied = $("#PrintedVersionSupplied"),
    $clientDetailsConsented = $("#ClientDetailsConsented"),
    $clientLogisticsProviderAgreed = $("#ClientLogisticsProviderAgreed"),
    $clientPersonalDataTransferAgreed = $("#ClientPersonalDataTransferAgreed"),
    $institutionId = $('#InstitutionId'),
    $ctaCarer = $('.form--cta__carer'),
    $ctaConsent = $('.form--cta__consent'),
    isCarerPrimaryContact = false,
    isAccountCreated = false,
    hasCarer = false,
    isAnim = false,
    sectionInd = 1,
    dataParams = {},
    _isInvalid = [],
    $ndisEligibility = $('#NDISEligibility');

$(() => {
    if (!$newPatient.length) {
        return false;
    }

    // Put Loader in a variable
    let loader = new Loader();


    //Init Carer Detail form
    let carerDetailObj = new CarerDetail();
    carerDetailObj.init();

    //autofocus on DOB inputs
    autofocusDob();

    $(document).ready(function(e){
        initiateAutoCompleteSuburb($suburbStatePostcode, $addressSuburb, $addressPostCode, $addressState);
    });

    $patientHaveCarer.on('change', function () {
        let $this = $(this);

        hasCarer = $this.prop('checked');

        if (hasCarer) {
            $primaryContact
                .parent()
                .stop().clearQueue()
                .slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            $ctaCarer.stop().clearQueue()
                .slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            $ctaConsent.stop().clearQueue()
                .slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            $('.form--carer-details').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

        } else {
            $primaryContact
                .parent()
                .stop().clearQueue()
                .slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            $ctaCarer.stop().clearQueue()
                .slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            $ctaConsent.stop().clearQueue()
                .slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            $('.form--carer-details').slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
        }
    });

    $primaryContact.on('change', function () {
        let $this = $(this),
            isChecked = $this.prop('checked');

        isCarerPrimaryContact = isChecked;

        if (isCarerPrimaryContact) {
            $carerFirstName.prev().text($carerFirstName.prev().text() + ' *');
            $carerLastName.prev().text($carerLastName.prev().text() + ' *');
            $carerPrimaryNumber.prev().text($carerPrimaryNumber.prev().text() + ' *');
            $carerEmailAddress.prev().text($carerEmailAddress.prev().text() + ' *');
            $carerRelationshipToClientDefaultOption.text($carerRelationshipToClient.find('option.defaultOption').text() + ' *');
            // $carerRelationshipToClientDefaultOption.text($carerRelationshipToClient.first().text() + ' *');
            $newCarerRelationshipToClientDefaultOption.text($newCarerRelationshipToClient.first().text() + ' *');

            $homeNumber.prev().text($homeNumber.prev().text().replace(' *', ''));
            $emailAddress.prev().text($emailAddress.prev().text().replace(' *', ''));
            $homeNumber.attr('required', false);
            //removed as part of urgent request by Lucy: 250Jun-2020
            //$emailAddress.attr('required', false);

            $carerFirstName.attr('required', true);
            $carerLastName.attr('required', true);
            $carerPrimaryNumber.attr('required', true);
            //removed as part of urgent request by Lucy: 250Jun-2020
            //$carerEmailAddress.attr('required', true);
            $carerRelationshipToClient.attr('required', true);
        } else {
            $carerFirstName.prev().text($carerFirstName.prev().text().replace(' *', ''));
            $carerLastName.prev().text($carerLastName.prev().text().replace(' *', ''));
            $carerPrimaryNumber.prev().text($carerPrimaryNumber.prev().text().replace(' *', ''));
            $carerEmailAddress.prev().text($carerEmailAddress.prev().text().replace(' *', ''));
            $carerRelationshipToClientDefaultOption.text($carerRelationshipToClient.find('option.defaultOption').text().replace(' *', ''));
            $newCarerRelationshipToClientDefaultOption.text($newCarerRelationshipToClient.first().text().replace(' *', ''));

            $homeNumber.prev().text($homeNumber.prev().text() + ' *');
            $homeNumber.attr('required', true);
            $emailAddress.prev().text($emailAddress.prev().text() + ' *');
            
            //removed as part of urgent request by Lucy: 250Jun-2020
            //$emailAddress.attr('required', true);

            $carerFirstName.attr('required', false);
            $carerLastName.attr('required', false);
            $carerPrimaryNumber.attr('required', false);
            //removed as part of urgent request by Lucy: 250Jun-2020
            //$carerEmailAddress.attr('required', false);
            $carerRelationshipToClient.attr('required', false);
        }
    });

    $('.js-jump-section').on('click', function (e) {
        e.preventDefault();

        if (isAnim) {
            return false;
        }

        let $this = $(this),
            $parent = $this.parent(),
            el;

        sectionInd = $parent.index();

        switch (sectionInd) {
            case 1:
                el = $('.form--section');
                break;
            case 2:
                el = $('.form--contact-details');
                break;
            case 3:
                el = $('.form--carer-details');
                break;
            case 4:
                el = $('.form--delivery-details');
                break;
            case 5:
                el = $('.form--patient-consent');
                break;
        }

        gsap.to(window, {duration: 1,
            scrollTo: {
                y: el.offset().top - $header.outerHeight() - parseInt($header.css('top')),
                ease: "expo.inOut"
            },
            onComplete: function () {
                isAnim = false;
            }
        });
    });

    $('.js-set-patient-details').on('click', function (e) {
        e.preventDefault();

        // Define where to display ajax errors
        let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

        if (isAnim) {
            return false;
        }

        _isInvalid = [];

        if ($title.val() == '') {
            $title
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($firstName)) {
            $firstName
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($lastName)) {
            $lastName
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isValidDob()) {
            $dobDay.parent().removeClass('incomplete');
            $dobMonth.parent().removeClass('incomplete');
            $dobYear.parent().removeClass('incomplete');

            $('.dob .error').fadeOut({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

        } else {
            $dobDay.parent().addClass('incomplete');
            $dobMonth.parent().addClass('incomplete');
            $dobYear.parent().addClass('incomplete');

            $('.dob .error').fadeIn({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if ($gender.val() == '') {
            $gender
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if($urNumber.data('is-required') == true && $urNumber.val() == ''){
           $urNumber
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            _isInvalid.push(0);
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];

            $(this).removeClass('error');

            toggleProgressBar(2);

            goToNextSection('.form--contact-details');
        }

    });

    $('.js-set-carer-details').on('click', function (e) {
        e.preventDefault();

        // Define where to display ajax errors
        let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

        if (isAnim) {
            return false;
        }

        _isInvalid = [];

        var phoneRegEx = /^[0-9]{8,10}$/;

        if ($homeNumber.prop('required')) {

            if (isFieldEmpty($homeNumber) || !$homeNumber.val().match(phoneRegEx)) {
                $homeNumber
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }
        }

        if (!isFieldEmpty($mobileNumber) && !$mobileNumber.val().match(phoneRegEx)) {
            $mobileNumber
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }
        

        if (isFieldEmpty($ndisEligibility)) {
            $ndisEligibility
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if($emailAddress.prop('required')) {
            if (!isValidEmail($emailAddress.val()) || isFieldEmpty($emailAddress)) {
                $emailAddress
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
    
                _isInvalid.push(0);
            }
        } else {
            if (!isValidEmail($emailAddress.val()) && !isFieldEmpty($emailAddress)) {
                $emailAddress
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }
        }

        if(isCarerFormValid().length > 0){
            _isInvalid.push(0);
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            $(this)
                .siblings('.validation--message')
                .slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
            return false;
        } else {
            _isInvalid = [];

            $(this).removeClass('error');
            $(this)
                .siblings('.validation--message')
                .slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            toggleProgressBar(3);

            goToNextSection('.form--delivery-details');
        }

    });

    $('.js-set-delivery-details').on('click', function (e) {
        e.preventDefault();

        if (isAnim) {
            return false;
        }

        _isInvalid = [];

        if (isFieldEmpty($addressLine1)) {
            $addressLine1
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($addressPostCode)) {
            $addressPostCode
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($addressSuburb)) {
            $addressSuburb
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($addressState)) {
            $addressState
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];

            $(this).removeClass('error');

            toggleProgressBar(4);
            goToNextSection('.form--patient-consent');
        }

    });

    let chkboxValidation = function($chkBox){
        if($chkBox.prop("checked")) {
            $chkBox.parent().removeClass('error');
            return true;
        } else {
            $chkBox.parent().addClass('error');
            return false;
        }
    }

    $('.js-create-new-patient').on('click', function (e) {
        e.preventDefault();

        let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

        if (isAccountCreated || isAnim) {
            return false;
        }

        _isInvalid = [];

        let isChk1 = chkboxValidation($printedVersionSupplied),
            isChk2 = chkboxValidation($clientDetailsConsented),
            isChk3 = chkboxValidation($clientLogisticsProviderAgreed);

        if (!isChk1 ||
            !isChk2 ||
            !isChk3 
            //|| !$clientPersonalDataTransferAgreed.prop('checked')
            ) {
                _isInvalid.push(0);
        }

        if (_isInvalid.length > 0) {
            toaster('You must agree to all Terms, Conditions and Privacy to continue.', 'error');
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];

            loader.fadeIn();
            $(this).removeClass('error');
        }

        dataParams = {
            'InstitutionId': $institutionId.val(),
            'Details': {
                'Title': $title.val(),
                'FirstName': $firstName.val(),
                'LastName': $lastName.val(),
                'Dob': {
                    'Day': $dobDay.val(),
                    'Month': $dobMonth.val(),
                    'Year': $dobYear.val()
                },
                'Gender': $gender.val(),
                'ClientUr': $urNumber.val(),
                "PrimaryPhoneNumber": $homeNumber.val(),
                "SecondaryPhoneNumber": $mobileNumber.val() == '' ? null : $mobileNumber.val(),
                'EmailAddress': $emailAddress.val() == '' ? null : $emailAddress.val(),
                'NDISEligibility': $ndisEligibility.val()
            },
            'Carers': $patientHaveCarer.is(":checked") ? carerDetails() : null,
			'CarerIsPrimaryContact': isCarerPrimaryContact,
            "Address": {
                "Address1": $addressLine1.val(),
                "Address2": $addressLine2.val(),
                "Suburb": $addressSuburb.val(),
                "PostCode": $addressPostCode.val(),
                "State": $addressState.val(),
                "AdditionalNote": isFieldEmpty($addressAdditionalNotes) ? null : $addressAdditionalNotes.val()
            },
            "DoesClientHaveCarer": $patientHaveCarer.is(":checked"),
            "AgreeMarketing": $('#AgreeMarketing').prop('checked'),
            "AgreesToPrivacyPolicy": 1,
            'IsDoNotCallOpted': $doNotCall.prop('checked'),

        };

        $.ajax({
            url: '/api/clients',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'POST',
            headers: {__RequestVerificationToken: $('#new-client-form').find('input[name=__RequestVerificationToken]').val()},
            data: JSON.stringify(dataParams),
            success: function (data) {

                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });

                window.location.href = data.href;
            },
            error: function (error) {
                loader.fadeOut();
                displayErrors(error, $errorContainer);
            }
        });
    });
});
